export const PageEnum = {
  DASHBOARD: "Dashboard",
  ALLCALENDAR: "All Calendar",
  LISTS: "Lists",
  CREATIVES: "Creatives",
  OFFERS: "Offers",
  STRATEGIES: "Strategies",
  TAG_MANAGEMENT: "Tag Management",
  SMS_ANALYTICS: "SMS Analytics",
  SETTINGS: "Settings",
  SEARCH: "Search",
};

export const SettingsTab = {
  SMS_PRICING: "SMS Pricing",
  PUBLIC_PAGE_MANAGEMENT: "Public Page Management",
};

export const OperationType = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
};

export const ListType = {
  SMS: "SMS",
  Email: "Email",
};

export const CalendarType = {
  Calendar: "Calendar",
  List: "List",
};

export const StrategyTableSortType = {
  0: "name",
  1: "top_offer",
  2: "new_offer",
  3: "old_winner",
};

export const TagTableSortType = {
  0: "name",
};

export const OfferTableSortType = {
  0: "name",
  1: "totalRevenue",
  2: "creatives",
  3: "lists",
  4: "score",
  5: "emailScore",
  6: "smsScore",
};

export const CreativeTableSortType = {
  0: "name",
  1: "totalRevenue",
  2: "score",
  3: "numberOfSend",
  4: "offer_name",
  5: "last_used_at",
};

export const OfferDetailsTableSortType = {
  0: "name",
};

export const EmailListTableSortType = {
  0: "name",
  1: "segment",
  2: "slot",
};

export const SMSListTableSortType = {
  0: "name",
  1: "slot",
};

export const NewScheduleListType = {
  SMS: "SMS",
  Email: "E-mail",
};

export const CalendarStatusType = {
  SCHEDULED: "SCHEDULED",
  DONE: "DONE",
  CREATED: "CREATED",
};

export const ReputationBackground = {
  BAD: "#FED9D9",
  LOW: "#FFE1BE",
  MEDIUM: "#C4E1FF",
  HIGH: "#E6F3E0",
};

export const CreateLinkSourceId = {
  MYTACTICALPROMOS: "mytacticalpromos",
  MYTACTICAL: "mytactical",
};
